import gql from 'graphql-tag';

export const RediscoverReactionsTrialDetailsQuery = gql`
	query RediscoverReactionsTrialDetailsQuery {
		license {
			trialEndDate
		}
	}
`;
